import { ShieldUser, XIcon } from "lucide-react";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
} from "@pushpress/pushpress-ui";
import { useHistory } from "react-router-dom";
import SectionTitle from "../../shared/SectionTitle";
import type { LeadUserType, MemberUserType } from "../../../types";
import type { StaffRecordType } from "../../../../People/types";

type ParentAccountSectionProps = {
  parentAccountInfo?: MemberUserType | LeadUserType | StaffRecordType | null;
  subAccountUserUuid: string;
  handleOpenModal: () => void;
  setSelectedSubAccountUserUuid: (userUuid: string) => void;
};

export default function ParentAccountSection({
  parentAccountInfo,
  subAccountUserUuid,
  handleOpenModal,
  setSelectedSubAccountUserUuid,
}: ParentAccountSectionProps) {
  const history = useHistory();
  const {
    firstName = "No user",
    lastName = "Info",
    email = "--",
    imageUrl = null,
    userUuid = null,
  } = parentAccountInfo || {};

  const handleRemoveParentUser = () => {
    setSelectedSubAccountUserUuid(subAccountUserUuid);
    handleOpenModal();
  };

  return (
    <div className="tw-rounded-lg tw-border tw-p-4 tw-bg-white tw-flex tw-flex-col tw-gap-2">
      <div className="tw-flex tw-items-center tw-justify-between">
        <SectionTitle icon={ShieldUser} title="Parent Account" />
        <Button
          variant="destructive"
          size="sm"
          onClick={handleRemoveParentUser}
        >
          <XIcon className="tw-mr-2 tw-h-4 tw-w-4" />
          Remove Parent Account
        </Button>
      </div>
      <div
        className="tw-flex tw-items-center tw-gap-2 tw-w-1/2 tw-cursor-pointer hover:tw-text-primary hover:tw-bg-neutral-50"
        onClick={() => history.push(userUuid ? `/user/${userUuid}` : "/main")}
        onKeyDown={() => history.push(userUuid ? `/user/${userUuid}` : "/main")}
        role="button"
        tabIndex={0}
      >
        <Avatar className="tw-h-12 tw-w-12">
          <AvatarImage src={imageUrl} alt={firstName || "parent-account"} />
          <AvatarFallback className="tw-text-xl tw-text-primary">
            {firstName?.charAt(0).toUpperCase()}
            {lastName?.charAt(0).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <div className="tw-space-y-1">
          <p>
            {firstName} {lastName}
          </p>
          <p className="tw-text-xs tw-text-neutral-600">{email}</p>
        </div>
      </div>
    </div>
  );
}
